import { HelpButton } from "../help/HelpPanel";
import { useLocation } from "react-router-dom";
import { findPage } from "../shell/nav";
import { fromUrl } from "../shell/routes";
import type { ReactNode } from "react";

// A page's heading: where it sits and its Altekore code, from the menu (shell/nav.ts) when the page is one of its pages
export function PageHead({ crumb, title, code, children }: { crumb?: string; title: string; code?: string; children?: ReactNode }) {
  const loc = useLocation();
  const path = fromUrl(loc.pathname);
  const page = findPage(path);
  const c = code ?? page?.code;
  const where = page ? page.section.title : crumb;
  return (
    <header className="page-head">
      <div>{where && <p className="crumb muted">{where}</p>}<h1>{title}{c && <span className="code-badge">{c}</span>}</h1></div>
      <div className="actions">{children}<HelpButton code={c} title={title} /></div>
    </header>
  );
}

export const Loading = () => <p className="muted">Loading…</p>;
export const ErrorNote = ({ text }: { text: string | null | undefined }) => (text ? <p className="msg err" role="alert">{text}</p> : null);
export const Notice = ({ children }: { children: ReactNode }) => <p className="notice">{children}</p>;
